<template>
  <div>
    <Header title="学籍异动"></Header>
    <div class="find_select" v-if="schoolCode == '10689'">
			<div class="sem-drop">
				<div @click="semPicker = true">
					<p>{{ this.xnxqtext }}</p>
					<i></i>
				</div>
			</div>
			<van-popup v-model="semPicker" position="bottom">
				<van-picker show-toolbar :columns="xnxqOption" @cancel="semPicker = false" @confirm="semConfirm" :item-height="itemHeight" />
			</van-popup>
		</div>
    <NOdata v-if="this.changeList.length == 0 && isLoad" title="暂无异动信息~"></NOdata>
    <template v-else>
      <div class="grey-contain" v-for="(item,index) in changeList" :key="index" @click="changeDetail(item.alienationId,item.auditState)">
        <div>
          <p>{{item.semesterName}}</p>
          <span>异动类别：{{item.alienationType}}</span>
        </div>
        <p :class="item.auditState == '通过' ? 'text2' : 'text1'">{{item.auditState == '通过' ? '已通过' : item.auditState}}</p>
      </div>
    </template>
  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  export default {
    data(){
      return{
        schoolCode:sessionStorage.getItem('schoolCode'),
        changeList:[],
        isLoad:false,
        semPicker: false,
        itemHeight: 35,
        xnxqOption: [],
        xnxqval: '',
        xnxqtext:''
      }
    },
    created(){
      if(this.schoolCode == '10689'){
				this.getXnxq();
			}else{
        this.getList()
      }
    },
    methods:{
      async getList(){
        const param = {
					xnxqid:this.xnxqval
				}
        const res = await Api.getStatueAlienation(param)
        this.changeList = res.data;
        this.isLoad = true;
      },
      changeDetail(val,res){
        this.$router.push({
          path:'/student/changeDetail',
          query:{
            'id':val,
            'status':res
          }
        })
      },
      async getXnxq() {
        const res = await Api.findDictionry({ zzdtype: "xnxq" });
        if (res.code == "1") {
          this.xnxqOption = res.data.xnxq.map((item, index) => {
          if ( item.isdqxq == '1') {
            this.xnxqval = item.xnxq01id;
            this.xnxqtext = item.xqmc
          }
          return {
            text: item.xqmc,
            value: item.xnxq01id
          };
          })
        }
        this.xnxqOption.unshift({text:'全部',value:''})
        this.getList();
      },
      semConfirm(e, val) {
				this.semPicker = false;
				this.xnxqtext = e.text
				this.xnxqval = e.value;
				this.getList()
			},
    },
  }
</script>

<style lang="less" scoped>
  .grey-contain{line-height: 22px;display: flex;justify-content: space-between;}
  .grey-contain p{font-weight: 600;}
  .grey-contain span{color: @attendance-color-2;font-size: 12px;}
  .grey-contain .text1{font-size: 14px;color: @attendance-background-color-13;font-weight: 700;}
  .grey-contain .text2{font-size: 14px;color: @attendance-background-color-12;font-weight: 700;}

  .find_select {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid @attendance-border-color-6;
    padding: 20px 0 7px;
}
.find_select select {
    border: 0;
    background: 0;
    outline: 0;
}

.find_select .sem-drop {
    width: 80%;
}
.find_select .van-picker-column__item {
    margin: 0 30%;
}
.find_select .sem-drop > div {
    width: 45%;
}
.find_select .van-popup.van-popup--bottom {
    border-radius: 5px 5px 0 0;
}
.find_select .sem-drop p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
}
.find_select .sem-drop,
.find_select .sem-drop div {
    display: flex;
    align-items: center;
    color: @attendance-color-2;
    font-size: 14px;
    justify-content: center;
}
.find_select .sem-drop > div i {
    background: url(../../../../static/img/Triangle.png) no-repeat center;
    width: 10px;
    height: 10px;
    background-size: 10px 8px;
    margin-left: 5px;
}
.find_select .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
    font-weight: 600;
    color: @attendance-color-1;
}

.find_select .van-picker__columns::before {
    width: 140px;
    height: 1px;
    background-color: @attendance-background-color-2;
    content: '';
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
}
.find_select .van-picker__columns::after {
    width: 140px;
    height: 1px;
    background-color: @attendance-background-color-2;
    content: '';
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/student/statusManage/change.vue